import React from 'react';
import PropTypes from 'prop-types';
import { CompanyForm } from '../company-form';
import { SimpleTableComponent } from '../../../../../components/simple-table';
import { TABLE_COLUMNS_NAMES } from '../../constants';
import './styles.less';
import { CustomLoader } from '../../../../../components/custom-loader';

export const CompanyContent = ({
	companyInfo,
	isCompanyInfoLoading,
	isCompanyFormOpen,
	companyTaxInfo,
	companyContacts,
}) => {
	if (isCompanyFormOpen) {
		return <CompanyForm />;
	}

	if (isCompanyInfoLoading) {
		return <CustomLoader />;
	}

	return (
		<div>
			<>
				<div className="company-content__header_text_section">Информация о компании</div>
				<SimpleTableComponent
					rows={companyInfo}
					isTableDataLoading={isCompanyInfoLoading}
					columns={TABLE_COLUMNS_NAMES}
				/>
			</>
			{companyTaxInfo && !isCompanyInfoLoading && (
				<>
					<div className="company-content__header_text_section">Уставные документы</div>
					<SimpleTableComponent
						rows={companyTaxInfo}
						isTableDataLoading={isCompanyInfoLoading}
						columns={TABLE_COLUMNS_NAMES}
					/>
				</>
			)}
			{companyContacts.length !== 0 && !isCompanyInfoLoading && (
				<>
					<div className="company-content__header_text_section">Контактные лица</div>
					<SimpleTableComponent
						rows={companyContacts}
						isTableDataLoading={isCompanyInfoLoading}
						columns={TABLE_COLUMNS_NAMES}
					/>
				</>
			)}
		</div>
	);
};

CompanyContent.propTypes = {
	companyInfo: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.string)]).isRequired,
		}),
	),
	companyTaxInfo: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.string)]).isRequired,
		}),
	),
	companyContacts: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.string)]).isRequired,
		}),
	),
	isCompanyInfoLoading: PropTypes.bool.isRequired,
	isCompanyFormOpen: PropTypes.bool.isRequired,
};
